import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-amount-form-field',
  templateUrl: './amount-form-field.component.html',
  styleUrls: ['./amount-form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> AmountFormFieldComponent),
      multi: true
    }
  ]
})
export class AmountFormFieldComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() id = '';

  value = '';
  isDisabled = false;
  isValid = true;
  pattern = /^\d+(\.\d+)?$/;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (value: number) => {};
  onTouched = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value = inputValue;
    this.onChange(parseFloat(inputValue) || 0);
    this.validateInput()
  }

  validateInput(): void {
    const regExpression = this.pattern;
    this.isValid = regExpression.test(this.value);
  }

  validateDecimal(event: KeyboardEvent): void {
    // This avoids adding invalid input value to the total amount bill field
    const charCode = event.charCode || event.keyCode;
    const charStr = String.fromCharCode(charCode);
    if (!charStr.match(/^[0-9.]$/) || (charStr === '.' && (event.target as HTMLInputElement).value.includes('.'))) {
      event.preventDefault();
    }
  }
}
